import TableLayout from "../../../layout/main/TableLayout";
import { Column, Flex, Relative, Row } from "../../../../styles/CommonStyles";
import { formatNumber } from "../../../../core/utils/common";
import DateTime from "../../../common/utils/DateTime";
import useGetTableIndex from "../../../../core/hooks/layout/useGetTableIndex";
import { rewardsListAttributes } from "../../../../core/constants/headers";


const RewardsListTable = ({
    data
}) => {

    const { data: rewards } = data

    const { cs, headers } = rewardsListAttributes
    const { getTableIndex } = useGetTableIndex()


    return (
        <TableLayout
            headers={headers}
            cs={cs}
            data={!!rewards}
            hasWriteAccess={true}
        >
            {rewards?.map((item, idx) => {
                const affiliatedUserFullName = `${item.affiliatedUser?.firstName || '-'} ${item.affiliatedUser?.lastName || '-'}`;
                const userFullName = `${item.user?.firstName || '-'} ${item.user?.lastName || '-'}`;
                const amount = item.data?.amount ?? '-';
                const currency = item.data?.currency?.toUpperCase() ?? '-';
                const type = item.type || '-';

                return (
                    <Relative key={item._id}>
                        <Row cs={cs} index={idx}>
                            <Column>
                                {getTableIndex(idx)}
                            </Column>
                            <Column>{affiliatedUserFullName}</Column>
                            <Column>{userFullName}</Column>
                            <Column>{currency}</Column>
                            <Column>{formatNumber(amount)}</Column>
                            <Column>{type}</Column>
                            <Column center>
                                <DateTime dt={item.createdAt} />
                            </Column>
                        </Row>
                    </Relative>
                );
            })}

        </TableLayout>
    )
}



export default RewardsListTable
